if (!customElements.get('cart-quantity-break')) {
  customElements.define(
    'cart-quantity-break',
    class CarttQuantityBreak extends HTMLElement {
      constructor() {
        super();

        this.cartQTYBreak = document.querySelector('dbtfy-cart-quantity-break');
        this.data = Debutify.widgets['qty-breaks'];
      }

      connectedCallback() {
        if (!this.cartQTYBreak) return;

        this.itemCount = Number(this.dataset.itemCount);
        this.breaks = this.cartQTYBreak.querySelectorAll('.dbtfy-cart-quantity-break');
        this.highestDiscount = this.cartQTYBreak.querySelector('.dbtfy-cart-quantity-break__highest-discount');

        if (this.breaks.length > 0) {
          this.renderBreak(this.itemCount);
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      renderBreak(count) {
        var message = '';
        let previousData = null;
        if (count > 0) {
          for (let i = 0; i < this.breaks.length; i++) {
            const cartBreak = this.breaks[i];
            const text = this.data.text;
            const range = Number(cartBreak.dataset.range);
            const discount = cartBreak.dataset.discount.trim();

            if (range > count && !message) {
              const addToCount = range - count;
              message = text.replace('{count}', addToCount).replace('{discount}', discount);
              break; // Stop the loop once the message is found
            } else {
              previousData = cartBreak;
            }
          }

          if (previousData) {
            const discountCode = previousData.dataset.discountCode.trim();
            const savedDiscountCode = localStorage.getItem('cart_break_discount_code');
            if (discountCode && discountCode != savedDiscountCode) {
              localStorage.setItem('cart_break_discount_code', discountCode);
            }
          }

          if (!message) message = this.data.highest_discount_text;
        }

        const contents = this.querySelector('.dbtfy-cart-break');
        if (contents) {
          contents.querySelector('span').innerHTML = message;
        }
      }
    }
  );
}
